export function hasFutureProperty(obj:any) {
    return obj.hasOwnProperty('future');
}
